<template>
  <div class="content">
    <!-- <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">Paginated Tables</h2>
    </div> -->
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            Lista de Postos de Trabalho
          </h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <el-select
                  class="select-success mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-success"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div>
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      color="success"
                      clearable
                      prefix-icon="el-icon-search"
                      placeholder="Pesquisar postos"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
                <div>
                  <base-button
                    type="success"
                    class="animation-on-hover"
                    style="margin: 0px 5px 0px 5px;"
                    @click="cadastrarPosto()"
                    >Cadastrar</base-button
                  >
                </div>
              </div>
            </div>

            <el-table :data="queriedData">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column :min-width="90" align="right" label="Ações">
                <div slot-scope="props">
                  <el-tooltip
                    content="Gerar QRCode"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      v-show="props.row.qrcode == '1'"
                      @click.native="gerarQRCode(props.row)"
                      class="btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="fas fa-sharp fa-light fa-qrcode"></i>
                    </base-button>
                  </el-tooltip>
                  <el-tooltip
                    content="Editar"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click.native="editarPosto(props.$index, props.row)"
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                  </el-tooltip>

                  <el-tooltip
                    content="Excluir"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click.native="excluirPosto(props.$index, props.row)"
                      class="remove btn-link"
                      type="danger"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-trash-simple"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="font-weight-normal">
                Mostrando de {{ from + 1 }} a {{ to }} no total de
                {{ total }} Postos de Trabalho.
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
    <div id="imprimirFolha" v-show="false">
      <div class="row d-flex justify-content-center mt-0" style="height: 100%;">
        <div
          class="col-12 d-flex justify-content-center"
          style="flex-direction: column; align-tems: center;"
        >
          <div class="row">
            <div class="col-12 p-1 d-flex justify-content-center">
              <h3 class="modal-title">
                EMPREGADOR: <strong>{{ dadosPosto.razao_social }}</strong>
              </h3>
            </div>
            <div class="col-12 p-1 d-flex justify-content-center">
              <h3 class="modal-title">
                <strong>{{ dadosPosto.endereco }}</strong>
              </h3>
            </div>
          </div>
          <template>
            <qrcode-vue
              render-as="svg"
              class="d-flex m-2 justify-content-center"
              :value="posto"
              :size="size"
              level="H"
            />
          </template>
          <div class="row">
            <div class="col-12 d-flex justify-content-center">
              <img
                style="width: 350px; height: 80px; margin: 20px; align-self: center;"
                src="../../assets/img/mrm.png"
              />
            </div>
            <p
              class="col-12 d-flex justify-content-center"
              style="font-size: 18px !important;"
            >
              CONTATOS (092): 3644-100, 4141-4100, 98118-8393
            </p>
            <a
              class="col-12 d-flex justify-content-center"
              style="font-size: 18px;"
              href="https://rep671.com.br"
              target="_blank"
              >rep671.com.br</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import NotificationHorarioLimite from "../Notifications/NotificationHorarioLimite.vue";
import jwt from "jsonwebtoken";
import QrcodeVue from "qrcode.vue";
import Modal from "@/components/Modal.vue";

import FormPostoTrabalho from "./FormPostoTrabalho.vue";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    FormPostoTrabalho,
    QrcodeVue,
    Modal,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      isLoading: false,
      searchQuery: "",
      tableColumns: [
        {
          prop: "cpf_cnpj",
          label: "CPF/CNPJ",
          minWidth: 110,
        },
        {
          prop: "razao_social",
          label: "Nome",
          minWidth: 150,
        },
        {
          prop: "local",
          label: "Posto de Trabalho",
          minWidth: 150,
        },
        {
          prop: "dt_criacao",
          label: "Data de Criação",
          minWidth: 90,
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      posto: "",
      size: 400,
      openDialog: false,
      dadosPosto: {},
      printing: false,
    };
  },
  mounted() {
    this.listarPostos();
    // this.$root.$on("funcaoCadastrarFuncionario", (params) => {
    //   alert("ccccc");
    //   setTimeout(() => {
    //     this.cadastrarFuncionario(params);
    //   }, 1000);
    // });

    // this.$root.$on("funcaoEditarFuncionario", (params) => {
    //   setTimeout(() => {
    //     this.editarFuncionario(params);
    //   }, 1000);
    // });

    //this.notifyVue("top", "center");
  },
  methods: {
    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        component: NotificationHorarioLimite,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "warning",
        timeout: 30000,
      });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      } else {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          showConfirmButton: true,
        });
      }
    },

    listarPostos() {
      const th = this;
      const bodyFormData = {
        setDB: this.$cookies.get("db"),
      };

      const carregarFuse = () => {
        this.fuseSearch = new Fuse(this.tableData, {
          keys: ["razao_social", "fantasia", "cpf_cnpj"],
          threshold: 0.3,
        });
      };

      const formatarCpfCnpj = (valor) => {
        if (valor.length === 14) {
          valor = valor.padStart(14, "0");
          valor = valor.replace(
            /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            "$1.$2.$3/$4-$5",
          );
        } else {
          valor = valor.padStart(11, "0");
          valor = valor.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }

        return valor;
      };

      this.isLoading = true;

      this.axios
        .post("/api/empregador/listarTodosEmpregadores2", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          if (response.data.data.dados.length > 0)
            th.tableData = response.data.data.dados.map((d) => {
              d.local = d.local ? d.local : "Sem Dados";
              d.cpf_cnpj = formatarCpfCnpj(d.cpf_cnpj);
              d.dt_criacao = d.dt_criacao.substring(0, 10);
              return d;
            });
          carregarFuse();
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar postos de trabalho!",
            "error",
          );
        });
    },

    excluirPosto(index, row) {
      console.log("Excluir Posto", index, row);

      const th = this;
      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        idEmpregador: row.id,
      };

      this.isLoading = true;

      this.axios
        .post("/api/empregador/deletarEmpregadorPorId", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Posto de Trabalho excluído com sucesso!",
            "success",
          );
          th.listarPostos();
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao excluir posto de trabalho!",
            "error",
          );
        });
    },

    editarPosto(index, row) {
      let w1 = jwt.sign({ data: row }, "qXTflPwOaD", {
        expiresIn: "1h",
      });
      this.$router.push(`/cadEditPostoTrabalho/${w1}/2`);
    },

    gerarQRCode(row) {
      const json = { id: row.id, local: row.local };
      this.posto = JSON.stringify(json);
      this.dadosPosto = row;
      // this.openDialog = true;
      this.imprimirQRCode();
    },

    imprimirQRCode() {
      this.printing = true;
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
        this.$htmlToPaper("imprimirFolha", undefined, () => {
          this.printing = false;
        });
      }, 1000);
    },

    cadastrarPosto() {
      const th = this;
      const bodyFormData = {
        setDB: this.$cookies.get("db"),
      };

      this.isLoading = true;

      this.axios
        .post("/api/parametrizacao/verificaPermissaoCadPosto", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          console.log(response.data.dados.dados);
          th.isLoading = false;
          if (!response.data.dados.dados) {
            th.showSwal(
              "",
              "Erro",
              "Favor entrar em contato com setor comercial da MRM Sistemas para liberação de novos postos de trabalho",
              "error",
            );
          } else {
            th.$router.push(`/cadEditPostoTrabalho/null/1`);
          }
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao verificar permissão de cadastro de posto",
            "error",
          );
        });
    },
  },
  watch: {
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    openDialog(value) {
      if (!value) {
        this.posto = "";
        this.dadosPosto = {};
      }
    },
  },
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
